export enum IntegrationEnum {
  FACEBOOK = 'facebook',
  TABOOLA = 'taboola',
  TIKTOK = 'tiktok',
  KWAI = 'kwai',
  UTMIFY = 'utmify',
  GOOGLE_TAG_MANAGER = 'google_tag_manager',
  GOOGLE_ANALYTICS = 'google_analytics',
  GOOGLE_ADS = 'google_ads',
  WEBHOOK = 'webhook',
  BOTEXPRESS = 'botexpress'
}